var React = require('react');

function FlinkLogo (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"nonzero"},React.createElement("path",{"d":"M0 21.78V0h14.63v4.34h-9.7v4.93h7.38v4.22H4.93v8.29zM17.31 21.78V0h4.93v17.41h10.42v4.37zM35.27 21.78V0h4.93v21.78zM44.15 21.78V0h4.7l9.44 14.14V0h4.87v21.78h-4.48L49 7.38v14.4zM67.11 21.78V0H72v8.69L79.32 0H85l-7.48 8.49 8.49 13.29h-6l-5.82-9.5L72 14.76v7zM91.08 12.51V3H87V0h11.66v3h-4v9.47l-3.58.04zm8.62 0L100.19 0h3.07l3.23 5.26L109.73 0h3.17l.49 12.51h-3.3l-.26-7.35-2.55 4.31h-1.6l-2.55-4.15-.23 7.19h-3.2z"})));
}

FlinkLogo.defaultProps = {"viewBox":"0 0 114 22"};

module.exports = FlinkLogo;

FlinkLogo.default = FlinkLogo;
